//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
  state: {
    containers: [],
    totalCount: null,
    searchRequest: null,
  },
  mutations: {
    updateLoadList(state, containers) {
      state.containers = containers;
    },
    updateSearchLoadListRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async loadContainerList({ commit, state }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));


      if (requestToSend.moveInDate.startDate)
          {
            requestToSend.moveInDate.startDate = dateFormat.getLocalDate(requestToSend.moveInDate.startDate);
          }

      if (requestToSend.moveInDate.endDate)
      {
        requestToSend.moveInDate.endDate = dateFormat.getLocalDateEnd(requestToSend.moveInDate.endDate);
      }
      else
      {
        requestToSend.moveInDate.endDate = dateFormat.getLocalDateEnd(requestToSend.moveInDate.startDate);
      }


      // if (requestToSend.chzEndDate.startDate)
      //     {
      //       requestToSend.chzEndDate.startDate = dateFormat.getLocalDate(requestToSend.chzEndDate.startDate);
      //     }

      // if (requestToSend.chzEndDate.endDate)
      // {
      //   requestToSend.chzEndDate.endDate = dateFormat.getLocalDateEnd(requestToSend.chzEndDate.endDate);
      // }
      // else
      // {
      //   requestToSend.chzEndDate.endDate = dateFormat.getLocalDateEnd(requestToSend.chzEndDate.startDate);
      // }

      if (requestToSend.chzEndDate.startDate)
      {
          const date = moment(requestToSend.chzEndDate.startDate)
                      .endOf('d')
                      .toDate();
          // console.log(date)
          // console.log(date.getMonth())
          // console.log(date.getDate())
          var month = (date.getMonth() + 1).toString()
          if (month.length === 1)
          {
              month = '0' + month
          }
  
          var day = date.getDate().toString()
          if (day.length === 1)
          {
              day = '0' + day
          }
          requestToSend.chzEndDate.startDate = date.getFullYear() + '-' + month + '-' + day
      }

      if (requestToSend.chzEndDate.endDate)
          {
              const date = moment(requestToSend.chzEndDate.endDate)
                          .endOf('d')
                          .toDate();
      
                          var month = (date.getMonth() + 1).toString()
                          if (month.length == 1)
                          {
                              month = '0' + month
                          }
                  
                          var day = date.getDate().toString()
                          if (day.length == 1)
                          {
                              day = '0' + day
                          }
              requestToSend.chzEndDate.endDate= date.getFullYear() + '-' + month + '-' + day
          }
          else
          {
            if (requestToSend.chzEndDate.startDate != null)
            {
              const date = moment(requestToSend.chzEndDate.startDate)
                          .endOf('d')
                          .toDate();
              console.log(date)
              console.log(date.getMonth())
              console.log(date.getDate())
              var month = (date.getMonth() + 1).toString()
              if (month.length === 1)
              {
                  month = '0' + month
              }
      
              var day = date.getDate().toString()
              if (day.length === 1)
              {
                  day = '0' + day
              }
      
              requestToSend.chzEndDate.endDate = date.getFullYear() + '-' + month + '-' + day
            }
              
          }


      if (requestToSend.createDate.endDate) {
        requestToSend.createDate.endDate = moment(requestToSend.createDate.endDate)
          .endOf('d')
          .toDate();
      }
    
      if (requestToSend.createDate.startDate && !requestToSend.createDate.endDate) {
        requestToSend.createDate.endDate = moment(requestToSend.createDate.startDate)
          .endOf('d')
          .toDate();
      }
      var pageseq = 0;
      requestToSend.sendSeq = pageseq.toString();
      
      const st = performance.now();
      console.log("requesttosend: " + JSON.stringify(requestToSend));
      var result = [];
      var result1 = [];
      var result2 = []
      var p_recleft = 0;
      var process = 1;
      //await api.post('/api/w/gst/loadlistpartial', requestToSend)
      await newAPIPost('/api/w/gst/loadlistpartial', requestToSend)
                      .then( (val) => {
                        console.log("val: " + JSON.stringify(val));
                        result1 = val.loadlists;
                        state.totalCount = val.totalRecCount;
                        p_recleft = val.recLeft;
                        console.log("p_recleft: " + p_recleft);
                      });
     if (p_recleft > 0) {  
         pageseq = 1;
         process += 1;
         requestToSend.sendSeq = pageseq.toString();
         console.log("process: " + process);
         console.log("inner requesttosend: " + JSON.stringify(requestToSend));
         //await api.post('/api/w/gst/loadlistpartial', requestToSend)
         await newAPIPost('/api/w/gst/loadlistpartial', requestToSend)
                             .then(
                               (val) => {
                                  result2 =  val.loadlists;
                                  console.log("result2: " + JSON.stringify(result2));
                                  console.log("result2 length: " + result2.length);
                                  p_recleft = val.recLeft;
                                  console.log("p_recleft: " + p_recleft);
                               })
      }
      if (result1.length > 0) {
         result = [].concat(result1,result2);
      } else {
         result = result1;
      }

      // console.log("result length: " + result.length);                
      // if (result.length > 4000)                 
      //    console.log("result: " + JSON.stringify(result[4000]));               
      // else    
      //    console.log("result less than 4000: " + JSON.stringify(result[result.length - 1]));               
      // console.log("rec count: " + state.totalCount);                           
      commit('updateSearchLoadListRequest', fallbackRequest);
      return commit('updateLoadList', result);
    },
  },
  getters: {
    getLoadList: state => state.containers,
    getLoadTotalCount: state => state.totalCount    
  },
};
